import React, { useState, useEffect } from "react";
import "./MfiPage.css";
import BASE_URL from "../apiConfig";
import useRecaptcha from "../hooks/useRecaptcha";
import memberImg from "../images/member.jpg";
import loanImg from "../images/loan.jpg";
import collectionImg from "../images/collection.jpg";
import reportingImg from "../images/reporting.jpg";
import mobileImg from "../images/mobile.jpg";
import technopark from "../images/technopark.jpg";

function MfiPage() {
  const [formData, setFormData] = useState({
    full_name: "",
    phone: "",
    email: "",
    organization: "",
    challenges: ""
  });
  const [widgetId, setWidgetId] = useState(null);
  const { getResponse } = useRecaptcha();

  useEffect(() => {
    if (window.grecaptcha) {
      const container = document.getElementById("recaptcha-mfi");
      if (container && container.innerHTML === "") {
        try {
          const id = window.grecaptcha.render(container, {
            // sitekey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
             sitekey: window.RECAPTCHA_SITE_KEY,
          });
          setWidgetId(id);
        } catch (err) {
          console.error("reCAPTCHA MfiPage render error:", err);
        }
      }
    }
  }, []);

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.full_name || !formData.phone) {
      setMessage("❌ Name & Phone required");
      return;
    }

    const token = getResponse(widgetId);
    if (!token) {
      setMessage("❌ Please complete the reCAPTCHA");
      setLoading(false);
      return;
    }
    const fd = new FormData();
    Object.keys(formData).forEach(k => fd.append(k, formData[k]));
    fd.append("_type", "mfi_demo");
    fd.append("tk", token);

    try {
      const res = await fetch(
        BASE_URL + "/DemoApi/saveData",
        { method: "POST", body: fd }
      );

      const result = await res.json();

      if (result.status) {
        setMessage("✅ Demo Request Submitted");
        setFormData({
          full_name: "",
          phone: "",
          email: "",
          organization: "",
          challenges: ""
        });
      } else {
        setMessage("❌ " + (result.message || "Verification Failed"));
      }

    } catch (err) {
      console.error("Submission Error:", err);
      setMessage("❌ Submission Failed. Check Console.");
    }

    setLoading(false);
  };

  return (
    <>
      {/* HERO SECTION */}
      <div
        className="bg-container-mfi"
        style={{ backgroundImage: `url(${technopark})` }}
      ></div>

      <div className="mfi-wrapper">
        <div className="mfi-left">
          <h1>IGNOSI - MICRO</h1>
          <h2>Group & Center Individual Lending, Simplified</h2>
          <h3>Digitize JLG & SHG management with integrated tracking.</h3>

          <p>
            Digitize JLG & SHG management with integrated collection tracking, field monitoring and behavioral risk intelligence. Built for high-volume lending institutions managing group dynamics, collections and financial inclusion programs.
          </p>

          <ul>
            <li>Group & Center Individual Lending Automation</li>
            <li>Field Agent & Collection Management</li>
            <li>Regulatory Compliance Ready</li>
            <li>Financial Inclusion at Scale</li>
          </ul>
        </div>

        <div className="mfi-right">
          <form className="demo-form-mfi" onSubmit={handleSubmit}>
            <input
              name="full_name"
              placeholder="Full Name*"
              value={formData.full_name}
              onChange={handleChange}
            />

            <input
              name="phone"
              placeholder="Phone Number*"
              value={formData.phone}
              onChange={handleChange}
            />

            <input
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
            />

            <input
              name="organization"
              placeholder="Institution Name"
              value={formData.organization}
              onChange={handleChange}
            />

            <textarea
              name="challenges"
              placeholder="What challenges are you looking to solve?"
              value={formData.challenges}
              onChange={handleChange}
            />

            <div
              id="recaptcha-mfi"
              style={{ marginBottom: "15px" }}
            ></div>

            <button type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Book a Demo"}
            </button>

            {message && <p className="form-msg-mfi">{message}</p>}
          </form>
        </div>
      </div>

      {/* PLATFORM INTRO */}
      <div className="mfi-intro-wrapper">
        <div className="mfi-intro-section animate-fadeInUp">
          <div className="intro-content">
            <h2 className="gradient-text">Complete Digital Platform for MFIs, JLGs & SHGs</h2>
            <p>
              Built for high-volume lending institutions managing group dynamics, collections and financial inclusion programs. Empowering communities through smart digital finance.
            </p>
          </div>
          <div className="intro-image animate-fadeInUp">
            <img src={memberImg} alt="MFI Platform Visualization" />
          </div>
        </div>
      </div>

      {/* FEATURE FLOW */}
      <section className="mfi-feature-flow emerald-bg">
        {[
          {
            title: "Group Lending Management",
            items: [
              "Joint Liability Group (JLG) Management",
              "Self-Help Group (SHG) Module",
              "Group Dynamics & Hierarchy",
              "Group Meeting Scheduler",
              "Group Loan Disbursement",
              "Collection day and Agent Management"
            ],
            image: loanImg
          },
          {
            title: "Field Operations & Collection",
            items: [
              "Field Agent Mobile App",
              "Digital Collection System",
              "GPS Attendance",
              "Collection Sheet Generation",
              "Missed Collection Tracking",
              "Collection Demandsheet",
              "Center Training management",
              "Center Leader management",
            ],
            image: collectionImg,
            reverse: true
          }
        ].map((sec, i) => (
          <div key={i} className={`feature-row-layout ${sec.reverse ? 'reverse' : ''}`}>
            <div className="feature-content-vibrant animate-fadeInUp">
              <h2 className="white-text feature-heading">{sec.title}</h2>
              <div className="feature-items">
                {sec.items.map((it, idx) => (
                  <div key={idx} className="feature-pill animate-fadeInUp" style={{ animationDelay: `${idx * 0.1}s` }}>{it}</div>
                ))}
              </div>
            </div>
            <div className="feature-image-vibrant animate-fadeInUp">
              <img src={sec.image} alt={sec.title} />
            </div>
          </div>
        ))}
      </section>

      {/* RISK ENGINE */}
      <section className="risk-engine-vibrant slate-bg">
        <h2 className="white-text section-title animate-fadeInUp">Risk & Portfolio Intelligence</h2>
        <div className="risk-grid-vibrant">
          {[
            "PAR Tracking & Analytics",
            "Over-Indebtedness Checks",
            "Social Performance Management",
            "Early Warning Signal Alerts",
            "Automated Client Exit Management"
          ].map((r, i) => (
            <div key={i} className="risk-node-vibrant animate-fadeInUp" style={{ animationDelay: `${i * 0.1}s` }}>
              {r}
            </div>
          ))}
        </div>
      </section>

      {/* DIGITAL INCLUSION */}
      <section className="digital-ribbon-vibrant teal-bg">
        <h2 className="white-text section-title animate-fadeInUp">Digital Financial Inclusion</h2>
        <div className="digital-ribbon-grid-vibrant">
          {[
            "Biometric Aadhaar eKYC",
            "Remote Video KYC",
            "QR-Based Instant Collections",
            "Multi-Wallet Integration",
            "Multilingual SMS & Voice Alerts"
          ].map((d, i) => (
            <div key={i} className="digital-chip-vibrant animate-fadeInUp" style={{ animationDelay: `${i * 0.1}s` }}>
              {d}
            </div>
          ))}
        </div>
      </section>

      {/* BUSINESS INTELLIGENCE */}
      <section className="intel-dashboard-vibrant bg-offset-light">
        <div className="intel-layout">
          <div className="intel-content animate-fadeInUp">
            <h2 className="gradient-text section-title-left">Business Intelligence & Reporting</h2>
            <div className="intel-grid-vibrant">
              {[
                "Portfolio Quality Dashboard",
                "Regional Branch Performance",
                "Client Progress Monitoring",
                "Integrated Fund Management",
                "Automated Social Impact Reports"
              ].map((text, k) => (
                <div key={k} className="intel-block-vibrant animate-fadeInUp" style={{ animationDelay: `${k * 0.1}s` }}>
                  {text}
                </div>
              ))}
            </div>
          </div>
          <div className="intel-image-vibrant animate-fadeInUp">
            <img src={reportingImg} alt="Reporting Dashboard" />
          </div>
        </div>
      </section>

      {/* SPECIAL MODULES */}
      <section className="special-glass-vibrant dark-bg">
        <div className="special-layout">
          <div className="special-image animate-fadeInUp">
            <img src={mobileImg} alt="Specialized Modules" />
          </div>
          <div className="special-content animate-fadeInUp">
            <h2 className="white-text section-title-left">Specialized Microfinance Modules</h2>
            <div className="glass-grid-vibrant">
              {[
                "Government Scheme Integration",
                // "Weather-Based Micro Insurance",
                "Member Insurance Management",
                "Member Family Details Attatchment",
                "Livelihood Progress Tracking",
                "Center and group document and training management customizable platform"
                // "Community Leader Portal"
              ].map((s, i) => (
                <div key={i} className="glass-card-vibrant animate-fadeInUp" style={{ animationDelay: `${i * 0.1}s` }}>
                  {s}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default MfiPage;